import React from 'react';
import PropTypes from 'prop-types';

const GridLayout = ({
  children,
  columns,
  isTab,
  selectedTabIndex,
  columnsWidth = 80,
  isResponsive,
  className,
  alignCenter
}) => {
  return (
    <>
      <div
        className={`grid ${className} ${alignCenter ? 'grid-center' : ''}`}
        style={
          isResponsive
            ? {
                gridTemplateColumns: `repeat(auto-fill, minmax(${columnsWidth}px, 1fr))`
              }
            : {
                gridTemplateColumns: `repeat(${columns}, minmax(${columnsWidth}px, 1fr))`
              }
        }
      >
        {children}
      </div>
      {isTab && (
        <div className="grid_selector" style={{ marginBottom: 6 }}>
          <div
            style={{
              width: columnsWidth,
              height: 2,
              backgroundColor: '#000',
              transition: 'all 0.25s ease',
              transform: `translateX(${selectedTabIndex *
                (columnsWidth + 10)}px)`
              // gridColumnStart: selectedTabIndex
            }}
          />
        </div>
      )}
    </>
  );
};

GridLayout.propTypes = {
  children: PropTypes.node,
  columnsWidth: PropTypes.number,
  columns: PropTypes.number,
  isTab: PropTypes.bool,
  isResponsive: PropTypes.bool,
  selectedTabIndex: PropTypes.number,
  className: PropTypes.string
};

export default GridLayout;
